import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}
export function Input({
  label,
  error,
  helperText,
  className = '',
  ...props
}: InputProps) {
  return <div className="w-full" data-id="element-264">
      {label && <label className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-265">
          {label}
          {props.required && <span className="text-red-500 ml-1" data-id="element-266">*</span>}
        </label>}
      <input className={`w-full px-3 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${error ? 'border-red-500' : 'border-gray-300'} ${className}`} {...props} data-id="element-267" />
      {error && <p className="mt-1 text-sm text-red-600" data-id="element-268">{error}</p>}
      {helperText && !error && <p className="mt-1 text-sm text-gray-500" data-id="element-269">{helperText}</p>}
    </div>;
}